export default __webpack_public_path__ + "static/media/magon-1-lounge2-20220325-min.eabcc2ba.jpg";